import { useNavigate, useLocation } from 'react-router-dom'

const navItems = [
  { id: 'dashboard', path: '/', icon: '📊', label: 'Home' },
  { id: 'projects', path: '/projects', icon: '🏗️', label: 'Proyek' },
  { id: 'reports', path: '/reports', icon: '📋', label: 'Laporan' },
  { id: 'rab', path: '/rab', icon: '💰', label: 'RAB' },
  { id: 'materials', path: '/materials', icon: '📦', label: 'Material' },
  { id: 'workers', path: '/workers', icon: '👷', label: 'Pekerja' },
  { id: 'invoices', path: '/invoices', icon: '💳', label: 'Invoice' },
]

export default function MobileNav() {
  const navigate = useNavigate()
  const location = useLocation()
  const currentPath = location.pathname
  const currentId = currentPath === '/' ? 'dashboard' : currentPath.replace('/', '')

  return (
    <div className="mobile-nav">
      <div className="mobile-nav-inner">
        {navItems.map((item) => (
          <div
            key={item.id}
            className={`mobile-nav-item${currentId === item.id ? ' active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <span style={{ fontSize: 18 }}>{item.icon}</span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  )
}